export default "__VITE_ASSET__D$C$4vkA__"